module.exports = {"id":"152514","name":"Jason Puncheon","rating":"73","photo":"./data/images/photos/0/152514.png","club":{"name":"Crystal Palace","logo":"./data/images/clubs/CrystalPalace.png"},"positions":["MC","MG"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/JasonPuncheon0.json
// module id = 1928
// module chunks = 0